import { render, staticRenderFns } from "./FirePayment.vue?vue&type=template&id=33580515&"
import script from "./FirePayment.vue?vue&type=script&lang=js&"
export * from "./FirePayment.vue?vue&type=script&lang=js&"
import style0 from "./FirePayment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FirePayment.vue"
export default component.exports